module.exports = __webpack_public_path__ + "img/artwork-1.64434afb.png";